import { useParams } from "react-router-dom";
import Reports from "@/pages/Reports";
import { PrintPageStyle } from "@/components/print/PrintFrontMatter";

export default function PublicReport() {
  const { token } = useParams();
  return (
    <div className="min-h-screen bg-[#FBFAF8]" data-testid="public-report">
      <PrintPageStyle title="Ledelsesrapport" date="" />
      <div className="border-b border-[#EBE8E3] bg-white print-hide">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
          <div className="flex items-baseline gap-3">
            <span className="text-2xl font-semibold tracking-tight text-[#1A1919]">bsm<span className="text-[#A83232]">.</span></span>
            <span className="text-[10px] uppercase tracking-[0.2em] text-[#6B6A68]">vision in steel</span>
          </div>
          <span className="text-xs text-[#6B6A68]">Ledelsesrapport · fortrolig</span>
        </div>
      </div>
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-16 py-10">
        <Reports publicToken={token} />
      </div>
    </div>
  );
}
